export default function loadCss(url) {
  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = url;
  document.head.appendChild(css);
}